import { chat } from './protobufs/chat';

export interface BaseProtobuf {
  verify: (data: Record<string, any>) => string | null;
  create: (data: Record<string, any>) => Record<string, any>;
  encode: (data: Record<string, any>) => {
    finish: () => Uint8Array;
  };
  decode: (data: Uint8Array) => Record<string, any>;
}

export class Protobuf<
  T extends BaseProtobuf,
  D extends Exclude<Parameters<T['create']>[0], undefined>,
> {
  target: T;
  constructor(target: T) {
    this.target = target;
  }
  verify(data: D) {
    const errorMsg = this.target?.verify?.(data);
    if (errorMsg) {
      throw new Error(errorMsg);
    }
  }
  encode(data: D) {
    this.verify(data);
    return this.target?.encode(this.target?.create(data))?.finish?.();
  }
  decode(data: Uint8Array) {
    return this.target.decode(data);
  }
}

export const chatProtobufs = {
  sendMessageRequest: new Protobuf(chat.SendMessageRequest),
  sendMessageResponse: new Protobuf(chat.SendMessageResponse),
  notice: new Protobuf(chat.Notice),
  pullMessageIdListRequest: new Protobuf(chat.PullMessageIdListRequest),
  pullMessageSequence: new Protobuf(chat.PullMessageSequence),
  pullMessageIdListResponse: new Protobuf(chat.PullMessageIdListResponse),
  pullMessageInfoListRequest: new Protobuf(chat.PullMessageInfoListRequest),
  messageInfo: new Protobuf(chat.MessageInfo),
  pullMessageInfoListResponse: new Protobuf(chat.PullMessageInfoListResponse),
  messageArrivalReplyRequest: new Protobuf(chat.MessageArrivalReplyRequest),
  messageArrivalReplyResponse: new Protobuf(chat.MessageArrivalReplyResponse),
  readBurnMessageReplyRequest: new Protobuf(chat.ReadBurnMessageReplyRequest),
  readBurnMessageReplyResponse: new Protobuf(chat.ReadBurnMessageReplyResponse),
  getMediaCallTokenRequest: new Protobuf(chat.GetMediaCallTokenRequest),
  getMediaCallTokenResponse: new Protobuf(chat.GetMediaCallTokenResponse),
  mediaCallOperateRequest: new Protobuf(chat.MediaCallOperateRequest),
  mediaCallOperateResponse: new Protobuf(chat.MediaCallOperateResponse),
  mediaCallOperateV2Request: new Protobuf(chat.MediaCallOperateV2Request),
  mediaCallOperateV2Response: new Protobuf(chat.MediaCallOperateV2Response),
  mediaCallOperateCalleeV2Request: new Protobuf(chat.MediaCallOperateCalleeV2Request),
  mediaCallOperateCalleeV2Response: new Protobuf(chat.MediaCallOperateCalleeV2Response),
  syncMediaCallInfoRequest: new Protobuf(chat.SyncMediaCallInfoRequest),
  syncMediaCallInfoResponse: new Protobuf(chat.SyncMediaCallInfoResponse),
  syncMediaCallInfoV2Request: new Protobuf(chat.SyncMediaCallInfoV2Request),
  syncMediaCallInfoV2Response: new Protobuf(chat.SyncMediaCallInfoV2Response),
  pullGroupMsgReadReplyRequest: new Protobuf(chat.PullGroupMsgReadReplyRequest),
  pullGroupMsgReadReplyResponse: new Protobuf(chat.PullGroupMsgReadReplyResponse),
  directPush: new Protobuf(chat.DirectPush),
};
